import firebase from 'firebase';
import store from '@/store.js';

export var greencount = 0;
export var ambercount = 0;
export var redcount = 0;

export function browsertype() {
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
    var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
    if ((is_chrome) && (is_safari)) { is_safari = false; }
    if ((is_chrome) && (is_opera)) { is_chrome = false; }
    if (is_chrome) return "Chrome";
    if (is_safari) return "Safari";
    if (is_explorer) return "MSIE";
    if (is_firefox) return "Firefox";
    return "Unknown";
}

export function getsurveyage(tm) {
    //var date = new Date();
    //var ticks = ((date.getTime() * 10000) + 621355968000000000);
    //var s = (ticks - tm) / 10000000;
    var s = Math.floor(tm / 10000000);
    s = s + 3600;                               //this needs checking ????????????? BST
    var m = Math.floor(s / 60);
    var h = Math.floor(m / 60);
    var d = Math.floor(h / 24);
    h = h - (d * 24);
    m = m - (d * 24 * 60) - (h * 60);
    s = s - (d * 24 * 60 * 60) - (h * 60 * 60) - (m * 60);
    var str = "";
    if (d > 0) {
        if (d == 1) {
            str = "1 day ";
        }
        else {
            str = "" + d + " days ";
        }
        if (d < 10) {
            if (h == 1) {
                str += "1 hr";
            }
            else {
                str += "" + h + " hrs";
            }
        }
    }
    else {
        //less than a day
        if (h > 0) {
            if (h == 1) {
                str = "1 hr ";
            }
            else {
                str = "" + h + " hrs ";
            }
            if (m == 1) {
                str += "1 min";
            }
            else {
                str += "" + m + " mins";
            }
        }
        else {
            //less than an hour
            if (m == 0) {
                if (s == 1)
                    return "1 sec";
                else
                    return "" + s + " secs";
            }
            if (m == 1) {
                str = "1 min ";
            }
            else {
                str = "" + m + " mins ";
            }
            if (s == 1) {
                str += "1 sec";
            }
            else {
                str += "" + s + " secs";
            }
        }
    }
    return str;
}

export function contactcount() {
    return store.state.contacts.length;
}

export function daysinmonth(month, year) {
    return new Date(year, month, 0).getDate();
};

export function checkcache() {
    if (typeof localStorage === 'object') {
        try {
            localStorage.setItem('localStorage', 1);
            localStorage.removeItem('localStorage');
            //alert("cache OK");
        } catch (e) {
            Storage.prototype._setItem = Storage.prototype.setItem;
            Storage.prototype.setItem = function () { };
            alert('Your web browser does not support local cache management. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        }
    }
    //window.localStorage.clear();
}

export function monitorbandwidth(fname,filesize) {
    //here we check if there has needed to be a download
    //if so then we change monthly bandwidth figure for that user
    var nt = getsystemmillis();
    var dt = localStorage.getItem(fname);
    var usingbandwidth = false;
    if ((dt == null) || (dt == "undefined")) {
        usingbandwidth = true;
    }
    else {   
        var elapsed = nt - Number(dt);
        if (elapsed > 400000000) {
            usingbandwidth = true;
        }
    }
    if (usingbandwidth) {
        try {
            localStorage.setItem(fname, nt);
        }
        catch (er) {
            alert("cache management warning");
        }
        store.state.useraccount.usage.Bandwidth = store.state.useraccount.usage.Bandwidth + filesize;
        firebase.database().ref('useraccounts/' + store.state.user.uid + "/usage/Bandwidth").set(store.state.useraccount.usage.Bandwidth);
        return true;
    }
    return false;
}

export function OLDmonitorbandwidth(millisecs, filesize, uid) {
    //here we check if there has needed to be a download
    //if so then we change monthly bandwidth figure for that user
    //useraccounts.uid.useage.Bandwidth
    var rate = Math.round(10000 * millisecs / filesize);
    if (rate < 30) {
        store.state.useraccount.usage.Bandwidth = store.state.useraccount.usage.Bandwidth + filesize;
        firebase.database().ref('useraccounts/' + store.state.user.uid + "/usage/Bandwidth").set(store.state.useraccount.usage.Bandwidth);
    }
    return rate;
}

export function getsystemmillis() {
    var d = new Date();
    var t = d.getTime();
    return t;
}

export function nowmonth() {
    const date = new Date();  
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear()-2000;
    var str = "" + year +"-" + month;
    return str;
}

export function getshareparticipants(share) {
    var participants = [];
    if (share.Contacts != null) {
        share.Contacts.forEach(id => {
            participants.push(id);
        });
    }
    if (share.Groups != null) {
        share.Groups.forEach(id => {
            store.state.groups.forEach(group => {
                if (group.ID === id) {
                    group.Contacts.forEach(cid => {
                        var found = false;
                        participants.forEach(iid => {
                            if (iid == cid)
                                found = true;
                        });
                        if (!found)
                            participants.push(cid);
                    });
                }
            });
        });
    }
    return participants;
}

export function getcontact(id) {
    var result = null;
    store.state.contacts.forEach(contact => {
        if (contact.ID === id) {
            result = contact;
            return;
        }
    });
    return result;
}

export function getsurvey(id) {
    var result = null;
    store.state.surveys.forEach(survey => {
        if (survey.ID === id) {
            result = survey;
            return;
        }
    });
    return result;
}

export function gettags(mediaid,surveyid) {
    var tags = {};
    store.state.surveys.forEach(survey => {
        if (survey.ID === surveyid) {
            for (var key in survey.tags) {
                var tag = survey.tags[key];
                if (tag.MediaID === mediaid) {
                    tags[key] = tag;
                }
            };
        }
    });
    return tags;
}

export function tagcount(tags) {
    var count = 0;
    for (var key in tags) {
        count++;
    };
    return count;
}

export function sharetag(tag, id, ouid, surveyid) {
    //first get a list of shares that involve the survey and that are actively shared
    //need to get these from the survey owner
    var dbid = store.state.exploresurvey.DatabaseID;
    var uid = store.state.exploresurvey.CreatorID;
    var odbid = store.state.databaseid;
    var ouid = store.state.user.uid;
    if (dbid == null) {
        dbid = odbid;
    }
    var sharesRef = firebase.database().ref('databases/' + dbid + '/users/' + uid + '/mydata/myshares');
    sharesRef.orderByChild("Survey").equalTo(surveyid).on("value", function (snapshot) {
        if (snapshot.exists()) {
            snapshot.forEach(function (child) {
                if (child.val().ShareTime > 0) {
                    var participants = getshareparticipants(child.val());
                    participants.forEach(contactid => {
                        var contactRef = firebase.database().ref('databases/' + dbid + '/users/' + uid + '/mydata/mycontacts/' + contactid);
                        contactRef.on("value", function (csnapshot) {
                            var contact = csnapshot.val();
                            if (contact.Registered != null) {
                                var cdbid = contact.DatabaseID;
                                var cuid = contact.Registered;
                                var rating = tag.Rating;
                                if (ouid === cuid) {
                                    rating = rating.replace("*", "");
                                }
                                firebase.database().ref('databases/' + cdbid + '/users/' + cuid + '/tags/' + id + '/Total').set(tag.Total);
                                firebase.database().ref('databases/' + cdbid + '/users/' + cuid + '/tags/' + id + '/Rating').set(rating);
                            }
                        });
                    });
                }
            });
        }
    });
}

export function updatetag(tag,id,newtag){
    //called when new note is added or rating changes or a new tag is created
    //first update the owner of the survey where the tag sits
    //then share with all the others
    var dbid = store.state.exploresurvey.DatabaseID;
    var uid = store.state.exploresurvey.CreatorID;
    var odbid = store.state.databaseid;
    var ouid = store.state.user.uid;
    var sid = store.state.exploresurvey.ID;
    if (dbid == null) {
        dbid = odbid;
    }
    if (newtag) {
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/survey-data/' + sid + '/tags/' + id).set(tag);
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Read').set(tag.Total);
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Total').set(tag.Total);
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/SurveyID').set(sid);
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Rating').set(tag.Rating.replace("*", ""));
    }
    else {
        firebase.database().ref('databases/' + odbid + '/users/' + ouid + '/tags/' + id + '/Read').set(tag.Total);
        firebase.database().ref('databases/' + odbid + '/users/' + ouid + '/tags/' + id + '/Total').set(tag.Total);
        firebase.database().ref('databases/' + odbid + '/users/' + ouid + '/tags/' + id + '/Rating').set(tag.Rating.replace("*",""));

        if (tag.Notes != null) {
            firebase.database().ref('databases/' + dbid + '/users/' + uid + '/survey-data/' + sid + '/tags/' + id + '/Notes').set(tag.Notes);
        }
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/survey-data/' + sid + '/tags/' + id + '/Rating').set(tag.Rating.replace("*", ""));
        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/survey-data/' + sid + '/tags/' + id + '/Total').set(tag.Total);

        if (ouid != uid) {
            firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Total').set(tag.Total);
            firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Rating').set(tag.Rating);
        }
    }
    store.state.mytags[id].Rating = tag.Rating.replace("*", "");
    store.state.mytags[id].Total = tag.Total;
    store.state.mytags[id].Read = tag.Total;
    sharetag(tag, id, ouid, store.state.exploresurvey.ID);
}

export function readtag(tag, id) {
    var dbid = store.state.databaseid;
    var uid = store.state.user.uid;
    firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Read').set(tag.Total);
    firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + '/Rating').set(tag.Rating.replace("*", ""));
    store.state.mytags[id].Rating = tag.Rating.replace("*", "");
    store.state.mytags[id].Total = tag.Total;
    store.state.mytags[id].Read = tag.Total;
}

export function findalert(alerts, surveyid) {
    var kalert = null;
    alerts.forEach(alert => {
        if (alert.SurveyID === surveyid) {
            kalert=alert;
        }
    });
    return kalert;
}

export function setalerts(shares, surveys) {
    greencount = 0;
    ambercount = 0;
    redcount = 0;
    var alerts = [];
    for (var key in store.state.mytags) {
        var tag = store.state.mytags[key];
        var surveyid = tag.SurveyID;
        var survey = getsurvey(surveyid);
        var alert = findalert(alerts, surveyid);
        if (alert == null) {
            alerts.push({ Name: survey.Name, StartTime:survey.StartTime, SurveyID: surveyid, greencount: 0, ambercount: 0, redcount: 0, greentotal: 0, ambertotal: 0, redtotal: 0 });
            alert = findalert(alerts, surveyid);
        }
        var addtotal = tag.Total;
        if (addtotal > 1)
            addtotal = addtotal - 1;
        if (tag.Rating.includes("green")) alert.greentotal += addtotal;
        if (tag.Rating.includes("amber")) alert.ambertotal += addtotal;
        if (tag.Rating.includes("red")) alert.redtotal += addtotal;
        if ((tag.Total > tag.Read)||(tag.Rating.includes("*"))) {
            var noteworthy = tag.Total - tag.Read;
            if ((tag.Total > 1) && (tag.Read == 0))
                noteworthy = noteworthy - 1;
            if (tag.Rating.includes("*")) {
                noteworthy++;
            }
            if ((tag.Total > tag.Read) || (tag.Rating.includes("*"))) {
                if (tag.Rating.includes("green")) {
                    alert.greencount += noteworthy;
                    greencount += noteworthy;
                }
                if (tag.Rating.includes("amber")) {
                    alert.ambercount += noteworthy;
                    ambercount += noteworthy;
                }
                if (tag.Rating.includes("red")) {
                    alert.redcount += noteworthy;
                    redcount += noteworthy;
                }
            }
        }
    };
    return alerts;
}

export function updatealerts() {
    store.state.alerts = setalerts(store.state.shares, store.state.surveys);
    store.state.greenalertcount = greencount;
    store.state.amberalertcount = ambercount;
    store.state.redalertcount = redcount;
    store.state.updatecount++;
}

export function dateticks() {
    var date = new Date();
    var dt = (date.getTime() * 10000);
    var ot = 621355968000000000;
    var ticks = (dt + ot);
    return ticks;
}

export function firebaseid(t) {
    var r = Math.random() * 9999;
    var s = "" + Math.floor(r);
    while (s.length < 4) {
        s = "0" + s;
    }
    var id = "" + t;
    var n = id.length;
    id = id.substring(0, n - 4) + s;
    return id;
}

export function getfirebaseid() {
    var dt = dateticks();
    return firebaseid(dt);
}

export function digit2(v) {
    var str = "" + v;
    if (str.length < 2) {
        str = "0" + str;
    }
    return str;
}

export function sharename(tg) {
    var date = new Date();
    var dte = date.toDateString();
    var arr = dte.split(" ");
    var hrs = date.getHours();
    var min = date.getMinutes();
    var str = arr[2] + "-" + arr[1] + "-" + arr[3].substring(2, 4) + " " + digit2(hrs) + ":" + digit2(min) + " " + tg;
    //alert(str);
    return str;
}

export function callcloudfunction(funcname, kind, info, vue, returnfunc) {
    //alert("callcloudfunction " + funcname);
    var theUrl = "https://europe-west2-missionshare-2f93c.cloudfunctions.net/" + funcname;
    if (funcname === "sendMail") {
        theUrl += "?kind=" + kind;
        if (kind === "invite") {
            theUrl += "&email=" + info.email + "&invitor=" + info.invitor;
        }
        if (kind === "remind") {
            theUrl += "&email=" + info.email + "&invitor=" + info.invitor + "&invitoremail=" + info.invitoremail;
        }
        if (kind === "welcome") {
            theUrl += "&email=" + info.email + "&name=" + info.name;
        }
    }
    if (funcname === "checkTag") {
        theUrl += "?tagletters=" + info.tagletters + "&mode=" + kind;
    }
    if (funcname === "checkInvites") {
        theUrl += "?email=" + info.email;
    }
    //alert("callcloudfunction " + theUrl);
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            //alert(xmlHttp.responseText);
            if (returnfunc.length > 0) {
                vue.dispatch(returnfunc, xmlHttp.responseText);
            }
            else {
                vue.cloudReturn(xmlHttp.responseText);
            }
        }
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
    xmlHttp.send(null);
}

export function elapsedstring(tickstr) {
    var tm = Number(tickstr);
    var date = new Date();
    var ticks = ((date.getTime() * 10000) + 621355968000000000);
    var s = (ticks - tm) / 10000000;
    var m = Math.floor(s / 60);
    var h = Math.floor(m / 60);
    var d = Math.floor(h / 24);
    if (d > 0) {
        if (d == 1)
            return "1 day";
        else
            return "" + d + " days";
    }
    if (h > 0) {
        if (h == 1)
            return "1 hour";
        else
            return "" + h + " hours";
    }
    if (m < 2)
        return "1 minute";
    else
        return "" + m + " minutes";
}

export function gettagletters(name) {
    var tl = name[0];
    var n = name.indexOf(" ");
    if (n < 0)
        tl = tl + name[1];
    else
        tl += name[n + 1];
    tl.toUpperCase();
    return tl;
}

export function extendedtagnumber(number) {
    var str = "" + (Number(number) + 1);
    if (str.length == 1) return "0" + str;
    return str;
}

/*
export function sendemail(kind, info) {
    alert("sendEmail");
    var functions = firebase.functions();
    functions.region_ = "europe-west2";
    var sendEmail = functions.httpsCallable('sendEmail');
    sendEmail({ kind: kind, info: info }).then(function (result) {
        alert("worked" + result.data);
        var res = result.data;
    }).catch(function (error) {
        alert("error" + error.message);
        var code = error.code;
        var message = error.message;
        var details = error.details;
    });
}

var functions = firebase.functions();
functions.region_ = "europe-west2";
var addMessage = functions.httpsCallable('addMessage');
addMessage({ number1: 23, number2: 67 }).then(function (result) {
  alert("worked"+result.data);
  var res = result.data;
}).catch(function (error) {
  alert("error" + error.message);
  var code = error.code;
  var message = error.message;
  var details = error.details;
});
*/

